import { styled } from '@mui/material';
import { COLORS } from '../theme/color';
import { breakpoints } from '../theme/theme';

export const Container = styled('div')`
  width: 100vw;
  background-color: #f8f7f7;
  position: relative;
  padding: 20px 1rem 0;
  @media (max-width: ${breakpoints.md}px) {
    padding: 10px 10px 0px;
  }
`;

export const MainGridCon = styled('div')`
  width: 100%;
  padding: 2px 0rem 0;
  display: flex;
  justify-content: space-between;
  gap: 55px;
  margin: 0 auto;
  @media (max-width: ${breakpoints.md}px) {
    display: block;
  }
`;
export const CategoriesGridCon = styled('div')`
  width: 100%;
  padding: 2px 2px 0;
  display: flex;
  justify-content: space-between;
  gap: 55px;
  margin: 0 auto;
  @media (max-width: ${breakpoints.md}px) {
    display: block;
  }
`;

export const CategoriesLeft = styled('div')`
  @media (max-width: ${breakpoints.md}px) {
    // display: none;
  }
  a {
    min-width: 280px;
  }
  a.active,
  active:hover {
    background-color: ${COLORS.MainBlue};
    color: #fff;
    font-weight: 500;
  }
`;

export const AccountLeft = styled('div')`
  @media (max-width: ${breakpoints.md}px) {
    display: none;
  }
  a {
    height: 40px;
    min-width: 50px;
  }
  a.active {
    background-color: ${COLORS.SecBlue};
    color: ${COLORS.MainBlue};
    font-weight: 500;
    position: relative;
  }
  a.active:after {
    content: '';
    width: 4px;
    border-radius: 4px;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background-color: ${COLORS.MainBlue};
  }
`;

export const Right = styled('div')`
  width: 100%;
  min-width: 0;
  @media (max-width: ${breakpoints.md}px) {
    padding: 2px;
  }
`;
